import { Box, BoxProps, Center } from "@chakra-ui/react";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { CarouselArrow } from "./CarouselArrow";

const settings = {
  dots: false,
  fade: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  swipe: true,
  speed: 500,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <CarouselArrow />,
  prevArrow: <CarouselArrow />,
};

export const ImageCarousel: React.FC<{ extraSettings?: object } & BoxProps> = ({
  extraSettings,
  children,
  ...rest
}) => {
  const imagesChildrenLength = React.Children.count(children);
  const sliderSettings = { ...settings, ...extraSettings };
  if (!imagesChildrenLength) return null;
  if (imagesChildrenLength === 1) {
    return (
      <Center w={{ base: "100%", md: "70%" }} mx="auto">
        {children}
      </Center>
    );
  }
  if (imagesChildrenLength === 2 && (sliderSettings.slidesToShow === 3 || sliderSettings.slidesToShow === 2)) {
    sliderSettings.slidesToShow = 2;
    sliderSettings.arrows = false;
    sliderSettings.swipe = false;
  }

  return (
    <Box overflow="hidden" {...rest}>
      <Slider {...sliderSettings}>{children}</Slider>
    </Box>
  );
};
